<template >
  <div class="new-home-packs">
    <div class="pack-box trial-offer" >
      <p class="discover text-uppercase">
          Ontdek je pakket

        <span class="arrow-down"></span>
      </p>
      <h3>Dit geschenk is een onderdeel <br> van je
          proefperiode van <br> <span class="purple-text"> € 2 / 2 maanden </span> </h3>
      <p class="text-uppercase purple-text">Jij ontvangt</p>
      <ul>
        <li>Jouw magazines in zowel papieren als digitale versie</li>
        <li>Onbeperkt juridisch, fiscaal en technisch advies</li>
        <li>12 praktische gidsen per jaar</li>
        <li>Een door jou gekozen welkomstgeschenk</li>
      </ul>
    </div>
      <GiftChoiceList v-if="box === 'list'" ></GiftChoiceList>
      <GiftChoiceTableau v-if="box === 'tableau'" ></GiftChoiceTableau>
      <GiftChoiceTableauSchool v-if="box === 'school'" ></GiftChoiceTableauSchool>
      <GiftChoiceDynamic v-if="box === 'dynamic'" ></GiftChoiceDynamic>
      <GiftChoiceTableauAndroid v-if="box === 'android'" ></GiftChoiceTableauAndroid>
      <GiftChoiceTableauLenovo v-if="box === 'tableau_lenovo_coque'" ></GiftChoiceTableauLenovo>
<!--      <GiftChoiceArchos v-if="box === 'tableau-archos'" ></GiftChoiceArchos>-->
      <GiftChoiceCooking v-if="box === 'cooking'" ></GiftChoiceCooking>
      <GiftChoiceCooking2024 v-if="box === 'cooking2024'" ></GiftChoiceCooking2024>
  </div>
</template>
<script>
import GiftChoiceTableau from "../../nl/newComponents/GiftChoiceTableau";
import GiftChoiceTableauSchool from "../../nl/newComponents/GiftChoiceTableauSchool";
import GiftChoiceDynamic from "../../nl/newComponents/GiftChoiceDynamic";
import GiftChoiceTableauAndroid from "../../nl/newComponents/GiftChoiceTableauAndroid";
import GiftChoiceList from "../../nl/newComponents/GiftChoiceList";
import GiftChoiceCooking from "../../nl/newComponents/GiftChoiceCooking";
import GiftChoiceCooking2024 from "../../nl/newComponents/GiftChoiceCooking2024";
import GiftChoiceArchos from "../../nl/newComponents/GiftChoiceArchos";
import GiftChoiceTableauLenovo from "./GiftChoiceTableauLenovo";
export default {
    components: {GiftChoiceList, GiftChoiceCooking2024, GiftChoiceTableau, GiftChoiceTableauSchool, GiftChoiceDynamic, GiftChoiceTableauAndroid, GiftChoiceCooking, GiftChoiceArchos,GiftChoiceTableauLenovo},
    props: {
        box: {
            type: String,
            default: 'list'
        },
    },
};
</script>
